// By Default
import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import { RiUserForbidFill } from "react-icons/ri";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "auto",
  // minWidth: "90%",
  bgcolor: "#ffffff",
  boxShadow:
    "0 10px 30px rgba(16,69,70,0.12), 0 2px 8px rgba(16,69,70,0.08)",
  border: "1px solid #E5E9EB",
  borderRadius: "16px",
  outline: "none",
  overflow: "scroll",
  height: "auto",
};

export default function ModalWrapper({ open, setOpen, children }) {
  const handleClose = () => setOpen(false);
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <div className="flex flex-col p-4 px-6 text-ink">
              {children}
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
